<template>
    <div class='checkwrap' :class="{[addedWrapClass]: addedWrapClass}">
        <div class="checkbox">
            <slot name="input"></slot>
            <i class="zmdi zmdi-square-o"></i>
            <i class="zmdi zmdi-check-square"></i>
        </div>
        <label :for='inputID' :class="{sub: useSmallLabel, [addedLabelClass]: addedLabelClass}">{{ labelText }}</label>
    </div>
</template>

<script>
// "inputID": prop to pass in the ID used for slotted input to connect to it's label 
// "labelText": prop to pass in text for the checkbox label 
// "useSmallLabel": boolean prop used to add 'sub' class for a smaller 1rem label (default is 1.25rem label)
// "addedWrapClass" & "addedLabelClass": props that can be used to add classes to the component wrapper or label 
export default {
    name: 'CheckboxWrap',
    props: ['inputID', 'labelText', 'useSmallLabel', 'addedWrapClass', 'addedLabelClass']
}
</script>